import {
	AuthenticationApi,
	AuthorizeRequest,
	Configuration,
	JWTToken,
	SessionResponseDto,
	VerifyLinkDto,
	VerifyLinkRequest,
	VerifyOtpRequest,
} from "@api/client";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { appConfig } from "core/app.config";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "core/store/config";
import { UserFormValues } from "models/login";

enum AuthReducer {
	authUser = "[AUTHORIZATION] Auth User",
	verifyOTP = "[AUTHORIZATION] Verify OTP",
	verifyLink = "[AUTHORIZATION] Verify Link",
	setUser = "[AUTHORIZATION] Set User",
	recuperaPraticaEmail = "[AUTHORIZATION] Set Recupera Pratica Email",
	logout = "[AUTHORIZATION] Logout",
}

export const authAuthorize = createAsyncThunk<
	SessionResponseDto | undefined,
	UserFormValues | undefined,
	ThunkApiConfig
>(AuthReducer.authUser, async (request, { dispatch, extra, getState }) => {
	let user = getState()?.auth?.user;

	const _request: AuthorizeRequest = {
		signUpDto: {
			firstName: request?.firstName || user?.firstName!,
			lastName: request?.lastName || user?.lastName!,
			email: request?.email || user?.email!,
			phone: request
				? `${request?.prefix}${request?.phoneNumber}`
				: `${user?.prefix}${user?.phoneNumber}`,
			privacyCheck: request?.privacyCheck || user?.privacyCheck!,
		},
		isTest: false,
	};

	return await new AuthenticationApi(getConfiguration(Configuration, extra, getState))
		.authorize(_request)
		.then((res) => {
			if (res && request) dispatch(authSetUser(request));
			return res;
		});
});

export const authVerifyOTP = createAsyncThunk<JWTToken | undefined, number, ThunkApiConfig>(
	AuthReducer.verifyOTP,
	async (otp, { dispatch, extra, getState }) => {
		try {
			let state = getState().auth;

			if (state?.sessionId) {
				let request: VerifyOtpRequest = {
					userSessionDTO: {
						sessionId: state?.sessionId,
						emailOtpCode: otp,
						smsOtpCode: undefined,
						forceToken: appConfig.forceToken,
					},
				};

				return await new AuthenticationApi(
					getConfiguration(Configuration, extra, getState)
				).verifyOtp(request);
			}
		} catch (error) {
			errorHandler(error, dispatch);
		}
	}
);

export const authVerifyLink = createAsyncThunk<
	VerifyLinkDto | undefined,
	VerifyLinkRequest,
	ThunkApiConfig
>(AuthReducer.verifyLink, async (request, { dispatch, extra, getState }) => {
	try {
		return await new AuthenticationApi(getConfiguration(Configuration, extra, getState)).verifyLink(
			request
		);
	} catch (error) {
		return await errorHandler(error, dispatch);
	}
});

export const authSetUser = createAction<UserFormValues>(AuthReducer.setUser);

export const authLogout = createAction(AuthReducer.logout);

export const authRecuperaPraticaEmail = createAction<string>(AuthReducer.recuperaPraticaEmail);
